import Axios from "axios";
import QS from 'qs'
import store from '@/store/index.js';
import Vue from "vue";
import router from '@/router/index.js'
import i18n from "@/i18n"
import { baseApi, bbh } from '@/config';

const version = bbh

Axios.defaults.timeout = 10 * 1000;
Axios.defaults.headers.post["Content-Type"] = 'application/x-www-form-urlencoded;charset=UTF-8'
Axios.defaults.headers.version = version

// 通用的错误提示配置（offset/duration 完全一致）
const errMsgConfig = (message) => ({
  message,
  type: "error",
  offset: 210,
  duration: 1500,
})

// 登录失效的完整处理流程：清 token、清用户信息、提示、跳转
const forceLogout = (message) => {
  store.commit("setToken", '')
  store.commit("setUserIfno", {})
  Vue.prototype.$message.error(errMsgConfig(message))
  router.push('/login')
}

// logoutTip 用于防止 1500ms 内重复弹出登出提示
let logoutTip = true

Axios.interceptors.request.use(
  config => {
    config.baseURL = baseApi
    if (localStorage.getItem("token")) {
      config.headers.common["authorization"] = localStorage.getItem("token")
    }
    config.headers.common["imei"] = window.localStorage.getItem('fingerprintVal')
    return config
  },
  error => Promise.reject(error)
)

Axios.interceptors.response.use(
  (response) => {
    const { code, message } = response.data

    if (code == 200) {
      return response.data
    }
    if (code == 27) {
      return response.data
    }
    if (code == 401 || code == 403) {
      if (logoutTip) {
        logoutTip = false
        // 延迟重置标识，与提示持续时间保持同步
        window.setTimeout(() => { logoutTip = true }, 1500)
        forceLogout(message)
      }
      return response.data
    }
    if (code == 510) {
      Vue.prototype.$message.error(errMsgConfig(message))
      return response.data
    }
    // message === false 时静默吞掉，不提示
    if (message === false) {
      return
    }
    Vue.prototype.$message.error(errMsgConfig(message))
    return response.data
  },
  () => {
    Vue.prototype.$message.error(errMsgConfig(i18n.t('您的网络状态不好,请重试')))
    return Promise.reject(arguments[0])
  }
)

export function get(url, params) {
  return Axios.get(url, { params })
}

export function post(url, params, type) {
  if (type === 'file') {
    const formData = new FormData();
    formData.append('file', params.file);
    return Axios.post(url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  }
  return Axios.post(url, QS.stringify(params))
}

export function patch(url, params) {
  return Axios.patch(url, QS.stringify(params))
}
